import api from './api.service';
import { Photo } from '../types/photo';

class PhotosService {
  async list(entityType: string, entityId: string): Promise<Photo[]> {
    const response = await api.get(`/photos/${entityType}/${entityId}`);
    return response.data;
  }

  async upload(entityType: string, entityId: string, file: File): Promise<Photo> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/photos/${entityType}/${entityId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  async delete(photoId: string): Promise<void> {
    await api.delete(`/photos/${photoId}`);
  }

  async reorder(entityType: string, entityId: string, photoIds: string[]): Promise<Photo[]> {
    const response = await api.put(`/photos/${entityType}/${entityId}/reorder`, {
      photo_ids: photoIds,
    });
    return response.data;
  }
}

export const photosService = new PhotosService();
